<template>
  <div id="sidebar" class="menu-side" :class="{'menu-show': isCollapse }">
    <VuePerfectScrollbar  class="scroll-area"  :settings="settings" >  <!-- @ps-scroll-y="scrollHanle"  -->
    <div>
    <el-menu  unique-opened >
      <el-menu-item  :index="menu.linkName" v-for="menu in sidebar" :key="menu.title" v-if="menu.submenus==null">
        <router-link v-bind:to="'/' + menu.linkName"><svgicon :icon="menu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{menu.title}}</router-link>
      </el-menu-item>
      <el-submenu :index="menu.title" v-else>
        <template   slot="title"><svgicon :icon="menu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon><span class="text-uppercase submenuTitle">{{menu.title}}</span></template>
        <el-menu-item-group v-for="submenu in menu.submenus" :key="submenu.title">
          <el-menu-item v-if="submenu.childs==null" :index="submenu.title"><router-link v-bind:to="submenu.linkName" class="text-capitalize"><svgicon :icon="submenu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{submenu.title}}</router-link></el-menu-item>
          <el-submenu :index="submenu.title" v-else>
            <template   slot="title"><svgicon :icon="submenu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon><span class="text-uppercase submenuTitle">{{submenu.title}}</span></template>
              <el-menu-item :index="child.title" v-for="child in submenu.childs" :key="child.title"><router-link v-bind:to="child.linkName" class="text-capitalize"><svgicon :icon="child.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{child.title}}</router-link></el-menu-item>
          </el-submenu>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item  :index="page.identifier" v-for="page in Pages" :key="page.title">
        <a :href="'https://' + page.target_url " v-if="page.target_url" target="_blank"><svgicon icon="custompage" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{page.title}}</a>
        <router-link v-else :to="'/page/' + page.identifier"><svgicon icon="custompage" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{page.title}}</router-link>
      </el-menu-item>
    </el-menu>
    </div>
  </VuePerfectScrollbar>
  <!-- powered By echo logo -->
     <el-row type="flex" class="echoLogo">
        <el-col>
          <div>
            <p class="text-center">ECHO B2B <span class="version">v. 1.01</span></p>
          </div>
          <div class="powered">
            <p class="text-center">powered by <span><svgicon icon="logo-echo" width="50" height="50"  color="#b8b8b8" class="mr-4"></svgicon></span></p>
          </div>
        </el-col>
      </el-row>
</div>
    <!-- <el-aside id="sidebar" width='300' class="menu-side" :class="{'menu-show': isCollapse }">
    <el-menu  :default-active="$route.name"  style="min-height:100vh">
      <el-menu-item  :index="menu.linkName" v-for="menu in menus" :key="menu.title" v-if="menu.submenus==null">
        <router-link v-bind:to="menu.linkName"><svgicon :icon="menu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{menu.title}}</router-link>
      </el-menu-item>
      <el-submenu :index="menu.title" v-else>
        <template   slot="title"><svgicon :icon="menu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon><span class="text-uppercase submenuTitle">{{menu.title}}</span></template>
        <el-menu-item-group>
          <el-menu-item :index="submenu.title" v-for="submenu in menu.submenus" :key="submenu.title"><router-link v-bind:to="submenu.linkName" class="text-capitalize"><svgicon :icon="submenu.icon" width="22" height="18" color="#848484" class="mr-4"></svgicon>{{submenu.title}}</router-link></el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside> -->
</template>
<script>
import { mapState } from 'vuex'
import '@/compiled-icons/'
import svgicon from 'vue-svgicon'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'sidebar',
  components: {
    svgicon,
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 90
      },
      windowWidth: 0,
      windowHeight: 0
      // menus: [
      //   {title: this.$translation('Dashboard'), linkName: 'dashboard', icon: 'dashboard'},
      //   {title: 'tickets', linkName: 'tickets', icon: 'tickets'},
      //   {title: 'orders', linkName: 'orders', icon: 'orders'},
      //   {title: 'subscriptions', linkName: 'subscriptions', icon: 'subscriptions'},
      //   {title: 'invoices', linkName: 'invoices', icon: 'invoices'},
      //   {title: 'projects',
      //     linkName: 'projects',
      //     icon: 'projects',
      //     submenus: [
      //       {title: 'projects overview', linkName: 'projects', icon: 'projectsoverview'},
      //       {title: 'tasks', linkName: 'tasks', icon: 'tasks'}
      //     ]
      //   },
      //   {title: 'account',
      //     linkName: 'account',
      //     icon: 'account',
      //     submenus: [
      //       {title: 'activity', linkName: 'activity', icon: 'activity'},
      //       {title: 'files', linkName: 'files', icon: 'files'},
      //       {title: 'users', linkName: 'users', icon: 'users'}
      //     ]
      //   },
      //   {title: 'api', linkName: 'api', url: 'https://echodev.co/echo/api/documentation/', icon: 'api'},
      //   {title: 'about us', linkName: 'about', icon: 'aboutus'}
      //   // {title: 'custom page', linkName: 'custom page', icon: 'custompage'}
      // ]
      // menus: [
      //   {title: 'dashboard',
      //     linkName: 'dashboard',
      //     icon: 'profilency_dashboard',
      //     submenus: [
      //       {title: 'Announcements', linkName: 'announcements', icon: 'custompage'},
      //       {title: 'Upcoming meetings', linkName: 'upcomingmeetings', icon: 'custompage'},
      //       {title: 'Calendar', linkName: 'calendar', icon: 'custompage'}
      //     ]
      //   },
      //   {title: 'Profilings',
      //     linkName: 'profilings',
      //     icon: 'profilency_profilings',
      //     submenus: [
      //       {title: 'New profiling', linkName: 'newprofiling', icon: 'custompage'},
      //       {title: 'All profilings', linkName: 'allprofilings', icon: 'custompage'}
      //     ]
      //   },
      //   {title: 'Clients',
      //     linkName: 'clients',
      //     icon: 'pclients',
      //     submenus: [
      //       {title: 'New client', linkName: 'newclient', icon: 'custompage'},
      //       {title: 'All clients', linkName: 'allclients', icon: 'custompage'}
      //     ]
      //   },
      //   {title: 'Meetings',
      //     linkName: 'meetings',
      //     icon: 'profilency_meetings',
      //     submenus: [
      //       {title: 'New meeting', linkName: 'newmeeting', icon: 'custompage'},
      //       {title: 'Upcoming', linkName: 'upcoming', icon: 'profilency_meetings'},
      //       {title: 'My/All meetings', linkName: 'all meetings', icon: 'custompage'},
      //       {title: 'Past meetings', linkName: 'pastmeetings', icon: 'custompage'}
      //     ]
      //   },
      //   {title: 'Products & Services',
      //     linkName: 'productsandervices',
      //     icon: 'profilency_products',
      //     submenus: [
      //       {title: 'All products & services', linkName: 'allproductsandservices', icon: 'custompage'},
      //       {title: 'Strategic planning', linkName: 'strategicplanning', icon: 'custompage'}
      //     ]
      //   },
      //   {title: 'Statistics', linkName: 'statistics', icon: 'profilency_statistics'},
      //   {title: 'Configuration',
      //     linkName: 'configuration',
      //     icon: 'profilency_configuration',
      //     submenus: [
      //       {title: 'Settings',
      //         linkName: 'settings',
      //         icon: 'custompage',
      //         childs: [
      //           {title: 'Name', linkName: 'name', icon: 'custompage'},
      //           {title: 'Logo', linkName: 'logo', icon: 'custompage'},
      //           {title: 'Color', linkName: 'color', icon: 'custompage'},
      //           {title: 'Background image', linkName: 'backgroundimage', icon: 'custompage'},
      //           {title: 'Allow RMs to change priorities', linkName: 'rms', icon: 'custompage'}
      //         ]
      //       },
      //       {title: 'Reports', linkName: 'reports', icon: 'custompage'},
      //       {title: 'Profiling types',
      //         linkName: 'profilingtypes',
      //         icon: 'custompage',
      //         childs: [
      //           {title: 'New type', linkName: 'newtype', icon: 'custompage'},
      //           {title: 'All types', linkName: 'Alltypes', icon: 'custompage'}
      //         ]
      //       },
      //       {title: 'Developer',
      //         linkName: 'developer',
      //         icon: 'custompage',
      //         childs: [
      //           {title: 'Basic settings', linkName: 'basicsettings', icon: 'custompage'},
      //           {title: 'iframe', linkName: 'iframe', icon: 'custompage'},
      //           {title: 'api', linkName: 'api', url: 'https://echodev.co/echo/api/documentation/', icon: 'api'}
      //         ]
      //       }
      //     ]
      //   }
      // ]
    }
  },
  computed: {
    ...mapState('menu', {
      overlay: state => state.overlay
    }),
    ...mapState('menu', {
      isCollapse: state => state.openedMenu
    }),
    ...mapState('menu', {
      isMobile: state => state.mobile
    }),
    ...mapState('data', {
      Pages: state => state.Pages
    }),
    ...mapState('data', {
      sidebar: state => state.Sidebar
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth > 1219) {
        this.$store.state.menu.openedMenu = true
        this.$store.state.menu.mobile = false
      } else {
        this.$store.state.menu.openedMenu = false
        this.$store.state.menu.mobile = true
      }
    },
    // $route function is closing the menu sidebar, on route change, if the window size is less that 1200px
    $route () {
      // alert(this.$route.name)
      /**
       * * close menu sidebar on page change
       */
      if (this.$store.state.menu.mobile === true) {
        this.$store.state.menu.openedMenu = false
        this.$store.state.menu.overlay = false
      }
      /**
       * * close order details on page change
       */
      if (this.$store.state.menu.showOrderDetails === true) {
        this.$store.state.menu.showOrderDetails = false
      }
      /**
       * * close ticket details on page change
       */
      if (this.$store.state.menu.showTicketDetails === true) {
        this.$store.state.menu.showTicketDetails = false
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)
      // console.log(this.$store.state.menu.openedMenu)
      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  methods: {
    getWindowWidth: function () {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight: function () {
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  }
}
</script>
<style  lang="scss">
@import "../assets/scss/main.scss";
#sidebar
{
  text-align: left;
  height: 100vh;
//   width: 270px;
  transition: all .2s;
  background-color: #ffffff;
  z-index: 999;
  margin-top: 60px;
  position: fixed;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   overflow-y: scroll;
.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y {
    background-color: var(--main-color);
}
.scroll-area {
//   position: fixed;
  margin: auto;
  height: 85vh;
  width: 270px;
  background-color: #ffffff;
}
  .el-menu {
    padding-top: 5px;
  }
  .echoLogo
  {
    font-size: 10.2px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ababab;
    position: absolute;
    bottom: 60px;
    left: 40px;
    margin-top: 0;
    .version
    {
      padding: 5px;
      border-radius: 3.1px;
      background-color: #d8d8d8;
      font-size: 10.2px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;

    }
    .powered
    {
      margin-top: -20px;
      margin-left: 21px;
    }
  }
  .el-menu {
    border-right: none;
}
}
  .menu-side {
    // height: 100%;
    // width: 400px;
    position: fixed;
    top: 0;
    left: -270px;
    //  left: 0;
    padding: 0;
    list-style: none;
    background-color: rgba(0,0,3,.8);
    z-index: 1000;
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
    -webkit-transition: .3s ease;
    transition: .3s ease;
}
.menu-show {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
    -webkit-transition: .3s ease;
    transition: .3s ease;
}

a
{
  text-decoration: inherit;
  color: #5b5b5b;
  display: block;
}
.router-link-active
{
  text-decoration: inherit;
  color: var(--main-color);
  font-weight: bold;
  svg path
  {
    fill: var(--main-color) !important;
  }
}
.el-aside {
    color: var(--main-color);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    // ul
    //     {
    //       padding-top: 10px;
    //     }
  }
  .el-menu-item
  {
    border-left: 4px solid transparent !important
  }
  .el-menu-item.is-active
  {
      font-weight: bold !important;
      color: var(--main-color) !important;
      border-left: 4px solid var(--main-color) !important
  }
  .el-menu--collapse
  {
    width: 0px !important;
  }
  .el-menu-item
  {
    text-transform: uppercase;
  }
  .submenuTitle
  {
    font-size: 13px;
    color: #5a5a5a;
  }
  .el-submenu {
    border-left: 4px solid transparent;
  }
  .el-submenu.is-active.is-opened
  {
    .el-submenu__title
    {
       svg:first-child path
    {
      fill:var(--main-color) !important;
    }
    }
     border-left: 4px solid var(--main-color) !important;
     .mainIcon
     {
       color: var(--main-color) !important;
     }
     .el-menu-item.is-active {
      font-weight: bold !important;
      color: #03a7fa !important;
      border-left: 4px solid transparent !important;
    //   .submenuTitle
    // {
    //   font-weight: bold !important;
    //   color: var(--main-color) !important;
    // }
    }
    .submenuTitle
    {
      color: var(--main-color) !important;
      font-weight: bold !important;
    }
  }
  // .el-submenu.is-opened{
  //   border-left: 4px solid var(--main-color) !important;
  //   .mainIcon
  //    {
  //      color: var(--main-color) !important;
  //    }
  //   .submenuTitle
  //   {
  //     font-weight: bold !important;
  //     color: var(--main-color) !important;
  //   }
  //   .el-submenu__title
  //   {
  //      svg:first-child path
  //   {
  //     fill:var(--main-color) !important;
  //   }
  //   }
  // }
  @media (max-width: 1200px) {
   .menu-side
   {
     position: absolute;
     overflow-y: hidden;
     top: 0;
    //  height: 100vh;
   }
  }
  @media (max-width:970px) {
    #sidebar.collapse
    {
      width: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SidebarNew.vue